import utils from 'utils';

// `dottedNumber` inputs reformat their value on mount (1000 -> "1,000"), which
// with the default `===` comparison reads as dirty against the numeric initial
// value and keeps the FloatingActions bar visible. Compare by numeric value.
export const numberIsEqual = (a?: string | number, b?: string | number) =>
  utils.getIntegerFromDottedNumber(String(a ?? '')) ===
  utils.getIntegerFromDottedNumber(String(b ?? ''));

// Optional text fields have no initial value (`undefined`) until the user
// types something, but clearing an <input> always yields `''`, not
// `undefined`. Without this, that mismatch reads as dirty even though the
// field is effectively unchanged, keeping FloatingActions visible.
export const stringIsEqual = (a?: string, b?: string) =>
  (a || '') === (b || '');

export const FORM_DESCRIPTIONS = {
  PROFILE: {
    heading: 'profile',
    description: 'profileDescription',
  },
  ACCOUNT: {
    heading: 'account',
    description: 'accountDescription',
  },
} as const;

export const FORM_STEPS: Record<string, keyof typeof FORM_DESCRIPTIONS> = {
  PROFILE: 'PROFILE',
  ACCOUNT: 'ACCOUNT',
} as const;

export const FORM_ROUTE_TO_STEP: Record<
  string,
  keyof typeof FORM_DESCRIPTIONS
> = {
  profile: 'PROFILE',
  account: 'ACCOUNT',
} as const;

export const FORM_STEP_TO_ROUTE: Record<
  keyof typeof FORM_DESCRIPTIONS,
  keyof typeof FORM_ROUTE_TO_STEP
> = {
  PROFILE: 'profile',
  ACCOUNT: 'account',
} as const;

export const FORM_STEP_TO_NUMBER: Record<keyof typeof FORM_STEPS, number> = {
  PROFILE: 0,
  ACCOUNT: 1,
} as const;

export const FORM_NUMBER_TO_STEP: Record<number, keyof typeof FORM_STEPS> = {
  0: 'PROFILE',
  1: 'ACCOUNT',
} as const;
